<template>
    <div class="basicData sdeWrap" v-wechat-title="$t('现场作业报告')" ref="printArea">
        <Title :title="$t('现场作业报告')"/>
        <div class="form_box">
            <div class="form_box_line">
                <div class="form_box_line_item col4">
                    <div class="readonly_info">
                      <span class="ri_label">{{$t('客户名称') }}:</span>
                      <span class="ri_text" :title="data.clientName || '--'">{{data.clientName || '--'}}</span>
                    </div>
                </div>
                <div class="form_box_line_item col4">
                    <div class="readonly_info">
                      <span class="ri_label">{{$t('客户地址') }}:</span>
                      <span class="ri_text" :title="data.address || '--'">{{data.address || '--'}}</span>
                    </div>
                </div>
                <div class="form_box_line_item col4">
                    <div class="readonly_info">
                      <span class="ri_label">{{$t('派工单号') }}:</span>
                      <span class="ri_text" :title="data.dispatchSn || '--'">{{data.dispatchSn || '--'}}</span>
                    </div>
                </div>
                <div class="form_box_line_item col4">
                    <div class="readonly_info">
                      <span class="ri_label">{{$t('联系人') }}:</span>
                      <span class="ri_text" :title="data.contactName || '--'">{{data.contactName || '--'}}</span>
                    </div>
                </div>
            </div>
            <div class="form_box_line ise-psr">
                <div class="form_box_line_item col4">
                    <div class="readonly_info">
                      <span class="ri_label">{{$t('联系电话') }}:</span>
                      <span class="ri_text" :title="data.contactPhone || '--'">{{data.contactPhone || '--'}}</span>
                    </div>
                </div>
                <div class="form_box_line_item col4">
                    <div class="readonly_info">
                      <span class="ri_label">{{$t('服务工程师') }}:</span>
                      <span class="ri_text" :title="data.engineerName || '--'">{{data.engineerName || '--'}}</span>
                    </div>
                </div>
                <div class="form_box_line_item col4">
                    <div class="readonly_info">
                      <span class="ri_label">{{$t('区域') }}:</span>
                      <span class="ri_text" :title="data.areaName || '--'">{{data.areaName || '--'}}</span>
                    </div>
                </div>
                <div class="form_box_line_item col4">
                    <div class="readonly_info">
                      <span class="ri_label">{{$t('工号') }}:</span>
                      <span class="ri_text" :title="data.engineerSn || '--'">{{data.engineerSn || '--'}}</span>
                    </div>
                </div>
            </div>
            <div class="common_title account_custom">{{ $t('服务过程记录') }}</div>
            <div v-for="(equ, index) in data.repairMtList" :key="index">
              <div class="form_box_line">
                  <div class="form_box_line_item col4">
                      <div class="readonly_info">
                        <span class="ri_label">{{$t('设备类型') }}:</span>
                        <span class="ri_text" :title="equ.mtModelName || '--'">{{equ.mtModelName || '--'}}</span>
                      </div>
                  </div>
                  <div class="form_box_line_item col4">
                      <div class="readonly_info">
                        <span class="ri_label">{{$t('设备编号') }}:</span>
                        <span class="ri_text" :title="equ.mtSn || '--'">{{equ.mtSn || '--'}}</span>
                      </div>
                  </div>
                  <div class="form_box_line_item col4">
                      <div class="readonly_info">
                        <span class="ri_label">{{$t('到货日期') }}:</span>
                        <span class="ri_text">{{equ.deliveredDate || '--'}}</span>
                      </div>
                  </div>
                  <div class="form_box_line_item col4">
                      <div class="readonly_info">
                        <span class="ri_label">{{$t('保修状态') }}:</span>
                        <span class="ri_text">{{equ.warrantyStatus === 1 ? $t('保内') : $t('保外')}}</span>
                      </div>
                  </div>
              </div>
              <!-- <div class="form_box_line">
                  <div class="form_box_line_item col4">
                      <div class="readonly_info">
                        <span class="ri_label">{{$t('PLC版本') }}:</span>
                        <span class="ri_text" :title="equ.plcVersion || '--'">{{equ.plcVersion || '--'}}</span>
                      </div>
                  </div>
                  <div class="form_box_line_item col4">
                      <div class="readonly_info">
                        <span class="ri_label">{{$t('CNC版本') }}:</span>
                        <span class="ri_text" :title="equ.cncVersion || '--'">{{equ.cncVersion || '--'}}</span>
                      </div>
                  </div>
              </div> -->
              <div class="db_table">
                  <el-table :data="equ.serviceDetails" :cell-style="{borderSpacing:'5px'}">
                      <el-table-column :label="$t('服务类型')" align="center">
                          <template slot-scope="scope">
                              {{ scope.row.name || '--' }}
                          </template>
                      </el-table-column>
                      <el-table-column :label="$t('服务描述')" align="center">
                          <template slot-scope="scope">
                              <span :title="scope.row.detail">{{ scope.row.detail || '--' }}</span>
                          </template>
                      </el-table-column>
                      <el-table-column :label="$t('服务处理')" align="center">
                          <template slot-scope="scope">
                              <span :title="scope.row.process">{{ scope.row.process || '--' }}</span>
                          </template>
                      </el-table-column>
                      <el-table-column :label="$t('服务状态')" align="center">
                          <template slot-scope="scope">
                            {{ scope.row.serviceResultStr || '--' }}
                          </template>
                      </el-table-column>
                  </el-table>
              </div>
              <div class="db_table ise-mt10">
                  <el-table :data="equ.partReplacements" :cell-style="{borderSpacing:'5px'}" :empty-text="$t('无备件更换')">
                      <el-table-column :label="$t('备件名称')" align="center">
                          <template slot-scope="scope">
                              {{ scope.row.partName || '--' }}
                          </template>
                      </el-table-column>
                      <el-table-column :label="$t('新件型号')" align="center">
                          <template slot-scope="scope">
                              {{ scope.row.newPartModel || '--' }}
                          </template>
                      </el-table-column>
                      <el-table-column :label="$t('新件编号')" align="center">
                          <template slot-scope="scope">
                              {{ scope.row.newPartSn || '--' }}
                          </template>
                      </el-table-column>
                      <el-table-column :label="$t('旧件型号')" align="center">
                          <template slot-scope="scope">
                            {{ scope.row.usedPartModel || '--' }}
                          </template>
                      </el-table-column>
                      <el-table-column :label="$t('旧件编号')" align="center">
                          <template slot-scope="scope">
                              {{ scope.row.usedPartSn || '--' }}
                          </template>
                      </el-table-column>
                      <!-- <el-table-column :label="$t('供应商描述')" align="center">
                          <template slot-scope="scope">
                              {{ scope.row.supplierDescription || '--' }}
                          </template>
                      </el-table-column>
                      <el-table-column :label="$t('数量')" align="center">
                          <template slot-scope="scope">
                            {{ scope.row.Num || '--' }}
                          </template>
                      </el-table-column> -->
                  </el-table>
              </div>
            </div>
            <div class="common_title account_custom">{{ $t('服务结果') }}</div>
            <div class="form_box_line">
                <div class="form_box_line_item col4">
                    <div class="readonly_info">
                      <span class="ri_label">{{$t('报修时间') }}:</span>
                      <span class="ri_text">{{data.creationTime || '--'}}</span>
                    </div>
                </div>
                <div class="form_box_line_item col4">
                    <div class="readonly_info">
                      <span class="ri_label">{{$t('到达时间') }}:</span>
                      <span class="ri_text">{{data.arrivalTime || '--'}}</span>
                    </div>
                </div>
                <div class="form_box_line_item col4">
                    <div class="readonly_info">
                      <span class="ri_label">{{$t('完成时间') }}:</span>
                      <span class="ri_text">{{data.finishTime || '--'}}</span>
                    </div>
                </div>
                <div class="form_box_line_item col4">
                    <div class="readonly_info ri_label_long">
                      <span class="ri_label w">{{$t('备件更换') }}:</span>
                      <span class="ri_text">{{data.doesPartReplace ? $t('是') : $t('否')}}</span>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item col1">
                    <div class="readonly_info">
                      <span class="ri_label">{{$t('备注') }}:</span>
                      <span class="ri_text">{{data.remark || '--'}}</span>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item col1">
                    <div class="readonly_info">
                      <span class="ri_label">{{$t('服务评价') }}:</span>
                      <span class="ri_text">{{evaluationGradeMap(data.evaluationGrade)}}</span>
                    </div>
                </div>
            </div>
            <div class="signature_wrap">
              <div class="sw_left">
                <div class="sw_tip">{{$t('服务工程师姓名')}}</div>
                <div class="swl_name">{{data.engineerName}}</div>
              </div>
              <div class="sw_right">
                <div v-if="data.clientSignature" class="swr_signature">
                    <div class="sw_tip">{{$t('客户签字/日期')}}</div>
                    <img :src="data.clientSignature" @click="$showPic(data.clientSignature, '客户签字.png', false)" alt="" class="img img-thumbnail">
                </div>
                <div v-else>
                  <div class="sw_tip">{{$t('客户未签字（原因）')}}</div>
                  <div class="swr_reason" :title="data.unsignedReason">{{data.unsignedReason}}</div>
                </div>
                <div class="sw_date">{{data.signDate}}</div>
              </div>
            </div>
        </div>
        <div class="edit_btn_box">
          <button type="button" class="export_btn" @click="print()">{{ $t('打印') }}</button>
          <button type="button" class="back_btn" @click="$router.go(-1)">{{ $t('返回') }}</button>
        </div>
        <ServiceEquipmentInformatioReadOnly
          v-model="visible"
          :id="dialogId"
          idName="faultMtId"
          :requirementId="id"
          hasServiceTypeList
        />
    </div>
</template>

<script>
let warrantyStatus = [
    {
        0: '保外',
        1: '保内',
        2: '待定'
    }
]
import { DOMAIN } from "../../plugins/domain"
import dictionary from "../../plugins/dictionary"
    export default {
        data () {
            return {
                id: this.$route.query.id,
                data: {
                  baseInfo: {},
                  clientInfo: {},
                  dispatchInfo: {},
                  faultMts: [],
                  serviceProcess: {
                    engineerLocation: {}
                  }
                },
                readOnly: false,
                engineerOrgList: [],
                timeRange: [],
                dispatchPriority: dictionary.dispatchPriority,
                dispatchStatus: dictionary.dispatchStatus,
                infoSourceList: dictionary.infoSource,
                warrantyStatusArray: dictionary.warrantyStatusArray,
                auditStatusFilter: dictionary.auditStatusFilter,
                serviceDetailResultArray: dictionary.serviceDetailResultArray,
                isFreeArray: dictionary.isFreeArray,
                situationDescriptionArray: dictionary.situationDescriptionArray,
                auditStatus: dictionary.auditStatus,
                serverResults: dictionary.serverResults,
                warrantyStatus,
                logShow: false,
                loglist: [],
                dialogId: '',
                visible: false,
                areaList: [],
                engineerId: null,
                engineerOrgId: null,
                isCross: false,
                activeName: 'first',
            }
        },
        mounted () {
            this.initMounted()
        },
        methods: {
            initMounted () {
              this.read()
            },
            read () {
                this.$store.dispatch('a:searchServerList/onsiteReportView', {assistantReportId: this.id}).then(
                    res => {
                      this.data = res
                    },
                    rej => {
                      this.$message.error(rej.errorInfo);
                    }
                )
            },
            // 字典对比
            dictionaryCom (index, list) {
                if (index || index === 0) {
                    for (let item of list) {
                      if (item.id === index) {
                          return item.name
                      }
                    }
                }
                return ''
            },
            // 操作日志
            logView () {
              this.logShow = true
              this.$store.dispatch('a:searchDispatch/readRecordDetail', {id: this.id}).then(
                  res => {
                    this.loglist = res.recordList
                  },
                  rej => {
                    this.$message.error(rej.errorInfo);
                  }
              )
            },
            // 打印
            print () {
              console.log(DOMAIN.main)
              console.log(DOMAIN.main + 'pages/#/searchServerListReport?id=' + this.id, '_blank')
              window.open(DOMAIN.main + 'pages/#/searchServerListReport?id=' + this.id, '_blank')
              // this.$print(this.$refs.printArea)
            },
            evaluationGradeMap (evaluationGrade) {
              switch (evaluationGrade) {
                    case 5: 
                        return this.$t('非常满意')
                    case 4: 
                        return this.$t('满意')
                    case 3: 
                        return this.$t('一般')
                    case 2: 
                        return this.$t('不满意')
                    case 1: 
                        return this.$t('非常不满')
                    default:
                        return '--'
                }
            }
        }
    }
</script>

<style>
.check_box{
  padding-left: 100px;
}
.check_box .el-checkbox__label{
  font-size: 12px;
}
.sdeWrap .form_box .input_box .el-input__icon,.sdeWrap .el-date-editor .el-range-separator{
    line-height: 20px;
}
.sdeWrap .el-date-editor .el-range-input{
    font-size: 12px;
}
</style>
<style lang="scss" scoped>
.readonly_info{
  font-size: 12px;
  overflow: hidden;
  .ri_label{
    width: 140px;
    display: inline-block;
    text-align: right;
    margin-right: 10px;
    line-height: 44px;
  }
  span{
    float: left;
  }
}
.process {
  display: block;
  padding: 20px 27px 20px 65px;
  min-height: 130px;
  color: #B3B3B3;
  font-size: 12px;
  .process-photo {
    max-width: 120px;
    max-height: 140px;
    overflow: hidden;
  }
}
.process > div {
    float: left;
}
.process-staff {
    padding: 15px 30px 17px;
    color: #999999;
    dd{
      padding: 8px;
    }
}
.process-steps {
    margin-left: 10px;
    padding-top: 10px;
}
.process-steps > .step {
    float: left;
    width: 184px;
}
.status {
    float: left;
}
.content-active {
    color: #fabf40;
    .img {
        width: 82px;
        height: 82px;
    }
}
.step-content {
    float: left;
    text-align: center;
}
.step-content > p {
    padding-top: 10px;
}
.step-line {
    float: left;
    margin-top: 40px;
    width: 102px;
    height: 1px;
    background-color: rgba(254, 236, 198, 0.6);
}
.line-active {
    background-color: #f9bf41;
}
.location {
    float: left;
    width: 160px;
    padding-top: 3px;
}
.basicData{
  position: relative;
}
.log{
  position: absolute;
  text-decoration: underline;
  cursor: pointer;
  line-height: 24px;
  right: 56px;
  top: 12px;
  font-size: 12px;
}
.pra-right{
    position: absolute;
    right: 20px;
}
.tab_detail_box{
    width: 100%;
    padding: 5px 44px 15px;
    box-sizing: border-box;
    position: relative;
}
.db_item{
    width: 100%;
}
.db_ctrl{
    width: 100%;
    position: relative;
    height: 40px;
}
.dbc_btn{
    float: right;
    width: 26px;
    height: 26px;
    cursor: pointer;
    background-color: #fabf40;
    margin-left: 20px;
}
.second_title{
    line-height: 44px;
    font-size: 12px;
    padding-left: 74px;
}
.db_table, .db_box{
    .second_title{
        padding-left: 30px;
        background-position-x: 0;
    }
    .dbc_btn{
        margin-top: 9px;
    }
}
.basicData .form_box .db_item .form_box_line .col4 {
    width: 25%;
    .ri_label{
        width: 130px;
    }
}
.common_title .dbc_btn{
    margin-top: 3px;
    margin-right: -30px;
}
.edit_btn_box{
    .normal_gray_btn,.export_btn {
        border-radius: 4px;
    }
    .export_btn {
        width: auto;
        padding-left: 25px;
        padding-right: 15px;
    }
}
.img_link{
    display: inline-block;
    width: 100px;
    max-width: 120px;
    max-height: 150px;
    margin: 20px 20px;
    overflow: hidden;
    img{
        width: 100%;
    }
}
.ri_label_long .ri_label{
    width: 170px;
}
.ri_label_long .ri_text{
    width: 120px!important;
}
.addMt{
    position: absolute;
    top: 10px;
    right: 44px;
    cursor: pointer;
    z-index: 999;
}
.attachmentList{
    padding: 15px 44px 0;
}
.signature_wrap{
  width: 94%;
  height: 110px;
  border: 1px solid #F1F2F6;
  color: #999999;
  overflow: hidden;
  margin: 10px auto 0;
  font-size: 12px;
}
.sw_left{
  width: 50%;
  height: 110px;
  border-right: 1px solid #F1F2F6;
  float: left;
  box-sizing: border-box;
  position: relative;
}
.swl_name{
  line-height: 110px;
  text-align: center;
  font-size: 20px;
}
.swr_reason{
  width: 100%;
  height: 110px;
  overflow: hidden;
  line-height: 110px;
  text-align: center;
  font-size: 16px;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.sw_right{
  width: 50%;
  height: 110px;
  float: left;
  box-sizing: border-box;
  position: relative;
  .swr_signature{
    width: 100%;
    height: 90px;
    margin-top: 10px;
    text-align: center;
    overflow: hidden;
  }
  .img-thumbnail{
    height: 100%;
    cursor: pointer;
  }
}
.sw_date{
  position: absolute;
  right: 10px;
  bottom: 10px;
}
.sw_tip{
  position: absolute;
  left: 10px;
  top: 10px;
}
</style>
<style>
.ri_text .el-radio__label{
    font-size: 12px!important;
}
.ri_text .el-radio + .el-radio{
    margin-left: 25px!important;
}
.ri_text .el-radio{
    margin-right: 0;
    margin-left: 10px;
}
</style>
